import { useEffect, useState } from "react";
import { Accordion, Button, Modal } from "react-bootstrap";

import "./PaymentLatest.css";
import "../../css/slick-theme.css";
import "../../css/slick.css";
import "../../css/style.css";
import "../../css/responsive.css";

import { useDispatch, useSelector } from "react-redux";
import {
  openServiceListDisplayModel,
  openDocumentsDisplayModel,
} from "../../store/slices/modalSlice";
import axiosInstance from "../../api/axiosInstance";
import {
  setFromDeleteService,
  setFromDeleteDoc,
  setGlobalLoading,
} from "../../store/slices/IdSlice";

import ServiceListDisplayModel from "../../components/serviceListDisplayModel/serviceListDisplayModel";
import DocumentsDisplayModel from "../../components/documentsDisplayModel/documentsDisplayModel";
import CartPackage from "../../components/cartPackage/CartPackage";
import HandlePackageAndServiceModel from "../../components/handleModel/HandlePackageAndServiceModel";
import Payments from "../../components/Payment/Payments";
import PaymentDetails from "../../components/PaymentDetails/PaymentDetails";
import Coupons from "../../components/coupons/Coupons";
import Tips from "../../components/Tips/Tips";
import PreLoader from "../../components/preloader/PreLoader";
import { useUploadModal } from "../../context/UploadModalContext";

interface Field {
  preview: any;
  RecordId: number;
  Name: string;
  Label: string;
  PlaceHolder: string;
  TagLine: string | null;
  shortName: string | null;
  icon: string | null;
  Type: string;
  Options: any | null;
  IsRequired: boolean;
  IsPickupRequired: boolean;
  MaxLength: number | null;
  MinLength: number | null;
  FileTypes: string;
  Rows: number | null;
  Columns: number | null;
  CreatedAt: string;
  UpdatedAt: string | null;
  uploaded: boolean;
  isScraping: boolean;
  stored_name: string;
  ApplicantName: string;
  isGroup: number | null;
  multiOptions?: MultiFields[] | [];
  instructions?: Instructions[] | [];
}
interface MultiFields {
  preview: any;
  RecordId: number;
  Name: string;
  Label: string;
  PlaceHolder: string;
  TagLine: string | null;
  shortName: string | null;
  icon: string | null;
  Type: string;
  Options: any | null;
  IsRequired: boolean;
  IsPickupRequired: boolean;
  MaxLength: number | null;
  MinLength: number | null;
  FileTypes: string;
  Rows: number | null;
  Columns: number | null;
  CreatedAt: string;
  UpdatedAt: string | null;
  uploaded: boolean;
  isGroup: number | null;
  isScraping: boolean;
  stored_name: string;
}

interface Instructions {
  content: string;
  description: string;
  instructionId: number;
  title: string;
}

const PaymentLatest = () => {
  const dispatch = useDispatch();

  dispatch(setFromDeleteService(true));

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [responseData, setResponseData] = useState([] as any[]);

  const serviceListDisplayModel = useSelector(
    (state: { modal: { serviceListDisplayModel: boolean } }) =>
      state.modal.serviceListDisplayModel
  );

  const documentsDisplayModel = useSelector(
    (state: { modal: { documentsDisplayModel: boolean } }) =>
      state.modal.documentsDisplayModel
  );

  useEffect(() => {
    const uuidd = localStorage.getItem("uuid");
    if (uuidd) {
      fetchData(uuidd);
      setLoading(false);
    }
  }, []);

  const fetchData = async (uuidd: string) => {
    dispatch(setGlobalLoading(true));
    try {
      const response = await axiosInstance.get(
        `api/applicantUpload/getUploadDocuments?UUID=${uuidd}`
      );
      const result = response.data.data || {};
      if (result) {
        setResponseData(response.data.data);
      }
    } catch (error: any) {
      setError(true);
      if (error.response && error.response.status === 404) {
      }
      console.error("Error fetching data:", error);
    } finally {
      dispatch(setGlobalLoading(false));
    }
  };
  const { showUploadMobileModal, closeUploadMobileModal } = useUploadModal();
  const { showGuidelineMobileModal, closeGuidelineMobileModal } =
    useUploadModal();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [activeAccordion, setActiveAccordion] = useState<string | null>(null);

  const handleAccordionToggle = (key: string) => {
    setActiveAccordion(activeAccordion === key ? null : key);
  };

  const [applicantLabel, setApplicantLabel] = useState<string | null>(null);
  if (error) return null;

  return loading ? (
    <>
      <PreLoader />
    </>
  ) : (
    <>
      <section className="upload-new-main">
        <div className="d-block d-md-flex align-items-start gap-3">
          {!isMobile && (
            <div className="upload-left">
              <div>
                <div className="font-13 text-black-50 ff-medium mb-3">
                  Uploaded document based on the below applicants
                </div>
                <div className="applicant-list">
                  <Accordion activeKey={activeAccordion}>
                    {responseData &&
                      responseData.map(
                        (item: any, index: number) =>
                          item?.ServiceIncludedDetail.length && (
                            <Accordion.Item
                              eventKey={`active-${index}`}
                              className="applicant-box done"
                            >
                              <Accordion.Header>
                                <div
                                  className="d-flex justify-content-between align-items-center p-3 w-100"
                                  onClick={() =>
                                    handleAccordionToggle(`active-${index}`)
                                  }
                                >
                                  <div className="d-flex align-items-center gap-1">
                                    <div className="tick-sv-icon">
                                      <svg
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                          fill="#458E4A"
                                        />
                                      </svg>
                                    </div>
                                    <span
                                      className={`flag-icon flag-icon-${
                                        item.Applicant_Country
                                          ? item.Applicant_Country.toLowerCase()
                                          : "ae"
                                      } me-1`}
                                    ></span>
                                    <p className="mb-0 text-black ff-medium font-14 upload-aaplicant-name">
                                      &nbsp;
                                      {item.applicant_Name.length > 22
                                        ? `${item.applicant_Name.slice(
                                            0,
                                            22
                                          )}...`
                                        : item.applicant_Name}{" "}
                                      - {item.Applicant_PassPort}
                                    </p>
                                    <p className="mb-0 ms-2 d-flex">
                                      <svg
                                        width="14"
                                        height="9"
                                        viewBox="0 0 14 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1 1.5L7 7.5L13 1.5"
                                          stroke="#282828"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </p>
                                  </div>
                                  <div
                                    className="service-badge text-main ff-semibold font-13"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setApplicantLabel(
                                        item.applicant_Name +
                                          " - " +
                                          item.Applicant_PassPort
                                      );
                                      dispatch(
                                        openServiceListDisplayModel(
                                          item?.ServiceIncludedDetail
                                        )
                                      );
                                    }}
                                  >
                                    {item.ServiceIncludedDetail &&
                                    item.ServiceIncludedDetail.length > 0
                                      ? item.ServiceIncludedDetail.length
                                      : 0}{" "}
                                    Services
                                  </div>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <div className="upload-box p-0">
                                  <div className="upload-title d-flex align-items-center justify-content-between py-3 px-3 border-bottom mb-0 font-13 text-black ff-medium">
                                    <span>
                                      {" "}
                                      Total {item.FormFields.length} Documents
                                    </span>
                                    {item.FormFields.filter(
                                      (field: any) => field.uploaded
                                    ).length > 0 && (
                                      <div className="p-2 py-1 rounded-pill  bg-light-green text-dark-green ff-semibold font-11">
                                        {
                                          item.FormFields.filter(
                                            (field: any) => field.uploaded
                                          ).length
                                        }{" "}
                                        Uploaded{" "}
                                        <span className="ms-2">
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M10.5001 0.937925C11.5559 1.54752 12.4342 2.42229 13.048 3.47563C13.6619 4.52898 13.9899 5.72436 13.9998 6.94346C14.0096 8.16256 13.7009 9.36309 13.1042 10.4262C12.5075 11.4893 11.6434 12.3782 10.5976 13.0047C9.55179 13.6313 8.36046 13.9739 7.14156 13.9986C5.92265 14.0232 4.71844 13.7291 3.64813 13.1454C2.57782 12.5616 1.67853 11.7085 1.03928 10.6704C0.400028 9.63228 0.042987 8.44522 0.00350012 7.22672L0 6.99992L0.00350012 6.77312C0.0427028 5.56422 0.394488 4.3861 1.02456 3.35362C1.65463 2.32114 2.54149 1.46954 3.59867 0.881842C4.65585 0.294144 5.84727 -0.00959755 7.05679 0.000231172C8.26631 0.0100599 9.45264 0.333123 10.5001 0.937925ZM9.59502 5.10502C9.47448 4.9845 9.31411 4.9121 9.14399 4.9014C8.97387 4.89071 8.80569 4.94245 8.67101 5.04692L8.60521 5.10502L6.30008 7.40942L5.39497 6.50502L5.32917 6.44692C5.19447 6.34252 5.02632 6.29084 4.85624 6.30157C4.68616 6.3123 4.52584 6.38471 4.40534 6.50521C4.28484 6.62571 4.21243 6.78603 4.2017 6.95611C4.19097 7.12618 4.24265 7.29433 4.34705 7.42902L4.40515 7.49482L5.80517 8.89482L5.87097 8.95292C5.99373 9.04817 6.1447 9.09986 6.30008 9.09986C6.45546 9.09986 6.60642 9.04817 6.72918 8.95292L6.79498 8.89482L9.59502 6.09482L9.65312 6.02902C9.7576 5.89434 9.80934 5.72617 9.79864 5.55605C9.78795 5.38593 9.71554 5.22556 9.59502 5.10502Z"
                                              fill="#4E8059"
                                            />
                                          </svg>
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="p-2 pt-0 px-3 doc-listing-inside">
                                    {item.FormFields &&
                                    item.FormFields.length > 0 ? (
                                      item.FormFields.map(
                                        (field: Field, fieldIndex: number) => (
                                          <div
                                            className="doc-row"
                                            key={fieldIndex}
                                          >
                                            <div className="doc-left d-flex align-items-center gap-2 done">
                                              <div className="tick-sv-icon done">
                                                <svg
                                                  width="18"
                                                  height="19"
                                                  viewBox="0 0 18 19"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                                    fill="#458E4A"
                                                  />
                                                </svg>
                                              </div>
                                              <span className="each-doc-list">
                                                {field.Label}
                                              </span>
                                            </div>
                                            <div className="doc-actions d-flex align-items-center gap-2">
                                              <div
                                                className="d-flex align-items-center justify-content-center upEye"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  dispatch(
                                                    setFromDeleteDoc(false)
                                                  );
                                                  dispatch(
                                                    openDocumentsDisplayModel(
                                                      field
                                                    )
                                                  );
                                                }}
                                              >
                                                <img
                                                  src="https://goodhand.b-cdn.net/Assets/Upload/up-eye.svg"
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <div className="no-docs text-center py-3">
                                        No documents to upload
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                      )}
                  </Accordion>
                </div>
              </div>
            </div>
          )}

          <div className="upload-middle flex-grow-1">
            <div className="uploading-flow mt-3 rounded-top">
              <div className="d-md-flex d-none flex-column align-items-center col-md-11 mx-auto gap-3 text-dark-green up-badge-top pb-3 mb-5 ">
                <div className="secure-banner bg-2 font-14 px-3 py-2 rounded-3 d-flex align-items-center justify-content-center gap-2 w-100">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9981 0L12.1399 0.0084107L12.2108 0.0180231L12.2841 0.0336431L12.4175 0.0744951C12.5096 0.108454 12.5972 0.153653 12.6782 0.209067L12.8032 0.307593L13.1096 0.569527C15.5334 2.58277 18.5968 3.66384 21.7474 3.61782L22.1583 3.6058C22.427 3.59354 22.692 3.67177 22.9109 3.82796C23.1298 3.98415 23.29 4.20928 23.3658 4.4673C23.9563 6.47576 24.1369 8.58241 23.8971 10.6621C23.6573 12.7417 23.0019 14.752 21.9698 16.5733C20.9378 18.3947 19.5501 19.99 17.8893 21.2645C16.2285 22.5389 14.3285 23.4666 12.3021 23.9922C12.1043 24.0435 11.8967 24.0435 11.699 23.9922C9.67247 23.4667 7.77231 22.5392 6.11138 21.2647C4.45046 19.9903 3.06267 18.395 2.03048 16.5737C0.998299 14.7523 0.342782 12.742 0.102889 10.6623C-0.137004 8.58256 0.043622 6.47584 0.634033 4.4673C0.709862 4.20928 0.870062 3.98415 1.08899 3.82796C1.30792 3.67177 1.57292 3.59354 1.84157 3.6058C5.13073 3.75615 8.35757 2.6734 10.8903 0.569527L11.2063 0.299182L11.3217 0.209067C11.4027 0.153653 11.4903 0.108454 11.5824 0.0744951L11.717 0.0336431C11.7641 0.0222689 11.8118 0.0138417 11.86 0.0084107L11.9981 0ZM16.4558 8.76278C16.3442 8.65107 16.2117 8.56244 16.0659 8.50198C15.92 8.44151 15.7636 8.41039 15.6057 8.41039C15.4478 8.41039 15.2915 8.44151 15.1456 8.50198C14.9998 8.56244 14.8672 8.65107 14.7557 8.76278L10.799 12.7182L9.24542 11.1658L9.13248 11.0661C8.89098 10.8794 8.58746 10.7916 8.28356 10.8205C7.97967 10.8495 7.69819 10.993 7.49629 11.222C7.29439 11.451 7.18722 11.7482 7.19653 12.0533C7.20585 12.3584 7.33096 12.6486 7.54645 12.8648L9.94952 15.2679L10.0625 15.3676C10.2936 15.5469 10.5823 15.6358 10.8743 15.6174C11.1663 15.599 11.4416 15.4748 11.6485 15.2679L16.4546 10.4617L16.5543 10.3488C16.7337 10.1176 16.8225 9.82896 16.8041 9.53695C16.7858 9.24495 16.6615 8.96968 16.4546 8.76278H16.4558Z"
                      fill="#316E57"
                    />
                  </svg>
                  Your documents detail{" "}
                  <span className="ff-semibold">
                    protected with maximum security AES-256 encryption standards
                  </span>
                </div>
              </div>
              <Payments proceedToPay={true} />
            </div>
          </div>
          {!isMobile && (
            <div className="upload-right">
              <CartPackage hide={false} isDelete={false} />
              <Coupons />
              <Tips />
              <PaymentDetails />
              <div
                className="bg-white rounded-3 p-0 layout-border mt-4 "
                style={{ maxWidth: "425px", margin: "0 auto" }}
              >
                <div className="d-flex align-items-center mb-3 font-16 ff-bold px-3 py-2 bg-2">
                  <span className="me-2">
                    <img
                      src="https://goodhand.b-cdn.net/Assets/Upload/pay-cards.svg"
                      alt=""
                    />
                  </span>{" "}
                  We accept
                </div>
                <div className="px-4 pb-4 text-black-50">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/viss.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/sam-pay.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/master.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/apple-pay.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/amer-express.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {serviceListDisplayModel && (
          <ServiceListDisplayModel applicantLabel={applicantLabel ?? ""} />
        )}
        {documentsDisplayModel && <DocumentsDisplayModel />}
        <HandlePackageAndServiceModel />
      </section>

      {isMobile && (
        <>
          <Modal
            show={showUploadMobileModal}
            onHide={closeUploadMobileModal}
            scrollable
            className="mb-fix slide-from-bottom"
            backdrop="static"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className="applicant-list px-2">
                <Accordion activeKey={activeAccordion}>
                  {responseData &&
                    responseData.map(
                      (item: any, index: number) =>
                        item?.ServiceIncludedDetail.length && (
                          <Accordion.Item
                            eventKey={`active-${index}`}
                            className="applicant-box done"
                          >
                            <Accordion.Header>
                              <div
                                className="d-flex justify-content-between align-items-center p-3 w-100"
                                onClick={() =>
                                  handleAccordionToggle(`active-${index}`)
                                }
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <div className="tick-sv-icon">
                                    <svg
                                      width="18"
                                      height="19"
                                      viewBox="0 0 18 19"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                        fill="#458E4A"
                                      />
                                    </svg>
                                  </div>
                                  <span
                                    className={`flag-icon flag-icon-${
                                      item.Applicant_Country
                                        ? item.Applicant_Country.toLowerCase()
                                        : "ae"
                                    } me-1`}
                                  ></span>
                                  <p className="mb-0 text-black ff-medium font-14 upload-aaplicant-name">
                                    &nbsp;
                                    {item.applicant_Name.length > 22
                                      ? `${item.applicant_Name.slice(0, 22)}...`
                                      : item.applicant_Name}{" "}
                                    - {item.Applicant_PassPort}
                                  </p>
                                  <p className="mb-0 ms-2 d-flex">
                                    <svg
                                      width="14"
                                      height="9"
                                      viewBox="0 0 14 9"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M1 1.5L7 7.5L13 1.5"
                                        stroke="#282828"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                </div>
                                <div
                                  className="service-badge text-main ff-semibold font-13"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setApplicantLabel(
                                      item.applicant_Name +
                                        " - " +
                                        item.Applicant_PassPort
                                    );
                                    dispatch(
                                      openServiceListDisplayModel(
                                        item?.ServiceIncludedDetail
                                      )
                                    );
                                  }}
                                >
                                  {item.ServiceIncludedDetail &&
                                  item.ServiceIncludedDetail.length > 0
                                    ? item.ServiceIncludedDetail.length
                                    : 0}{" "}
                                  Services
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body className="p-0">
                              <div className="upload-box p-0">
                                <div className="upload-title d-flex align-items-center justify-content-between py-3 px-3 border-bottom mb-0 font-13 text-black ff-medium">
                                  <span>
                                    {" "}
                                    Total {item.FormFields.length} Documents
                                  </span>
                                  {item.FormFields.filter(
                                    (field: any) => field.uploaded
                                  ).length > 0 && (
                                    <div className="p-2 py-1 rounded-pill  bg-light-green text-dark-green ff-semibold font-11">
                                      {
                                        item.FormFields.filter(
                                          (field: any) => field.uploaded
                                        ).length
                                      }{" "}
                                      Uploaded{" "}
                                      <span className="ms-2">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.5001 0.937925C11.5559 1.54752 12.4342 2.42229 13.048 3.47563C13.6619 4.52898 13.9899 5.72436 13.9998 6.94346C14.0096 8.16256 13.7009 9.36309 13.1042 10.4262C12.5075 11.4893 11.6434 12.3782 10.5976 13.0047C9.55179 13.6313 8.36046 13.9739 7.14156 13.9986C5.92265 14.0232 4.71844 13.7291 3.64813 13.1454C2.57782 12.5616 1.67853 11.7085 1.03928 10.6704C0.400028 9.63228 0.042987 8.44522 0.00350012 7.22672L0 6.99992L0.00350012 6.77312C0.0427028 5.56422 0.394488 4.3861 1.02456 3.35362C1.65463 2.32114 2.54149 1.46954 3.59867 0.881842C4.65585 0.294144 5.84727 -0.00959755 7.05679 0.000231172C8.26631 0.0100599 9.45264 0.333123 10.5001 0.937925ZM9.59502 5.10502C9.47448 4.9845 9.31411 4.9121 9.14399 4.9014C8.97387 4.89071 8.80569 4.94245 8.67101 5.04692L8.60521 5.10502L6.30008 7.40942L5.39497 6.50502L5.32917 6.44692C5.19447 6.34252 5.02632 6.29084 4.85624 6.30157C4.68616 6.3123 4.52584 6.38471 4.40534 6.50521C4.28484 6.62571 4.21243 6.78603 4.2017 6.95611C4.19097 7.12618 4.24265 7.29433 4.34705 7.42902L4.40515 7.49482L5.80517 8.89482L5.87097 8.95292C5.99373 9.04817 6.1447 9.09986 6.30008 9.09986C6.45546 9.09986 6.60642 9.04817 6.72918 8.95292L6.79498 8.89482L9.59502 6.09482L9.65312 6.02902C9.7576 5.89434 9.80934 5.72617 9.79864 5.55605C9.78795 5.38593 9.71554 5.22556 9.59502 5.10502Z"
                                            fill="#4E8059"
                                          />
                                        </svg>
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div className="p-2 pt-0 px-3 doc-listing-inside">
                                  {item.FormFields &&
                                  item.FormFields.length > 0 ? (
                                    item.FormFields.map(
                                      (field: Field, fieldIndex: number) => (
                                        <div
                                          className="doc-row"
                                          key={fieldIndex}
                                        >
                                          <div className="doc-left d-flex align-items-center gap-2 done">
                                            <div className="tick-sv-icon done">
                                              <svg
                                                width="18"
                                                height="19"
                                                viewBox="0 0 18 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                                  fill="#458E4A"
                                                />
                                              </svg>
                                            </div>
                                            <span className="each-doc-list">
                                              {field.Label}
                                            </span>
                                          </div>
                                          <div className="doc-actions d-flex align-items-center gap-2">
                                            <div
                                              className="d-flex align-items-center justify-content-center upEye"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                dispatch(
                                                  setFromDeleteDoc(false)
                                                );
                                                dispatch(
                                                  openDocumentsDisplayModel(
                                                    field
                                                  )
                                                );
                                              }}
                                            >
                                              <img
                                                src="https://goodhand.b-cdn.net/Assets/Upload/up-eye.svg"
                                                alt=""
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div className="no-docs text-center py-3">
                                      No documents to upload
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        )
                    )}
                </Accordion>
              </div>
            </Modal.Body>
            <Modal.Footer className="shadow-none border-top">
              <Button
                variant="primary"
                className="w-100 fw-semibold py-3"
                onClick={closeUploadMobileModal}
              >
                OKAY, GOT IT
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showGuidelineMobileModal}
            onHide={closeGuidelineMobileModal}
            scrollable
            className="mb-fix slide-from-bottom"
            backdrop="static"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="shadow-none">
              <CartPackage hide={false} isDelete={false} />
              <Coupons />
              <Tips />
              <PaymentDetails />
              <div
                className="bg-white rounded-3 p-0 layout-border mt-4 "
                style={{ maxWidth: "425px", margin: "0 auto" }}
              >
                <div className="d-flex align-items-center mb-3 font-16 ff-bold px-3 py-2 bg-2">
                  <span className="me-2">
                    <img
                      src="https://goodhand.b-cdn.net/Assets/Upload/pay-cards.svg"
                      alt=""
                    />
                  </span>{" "}
                  We accept
                </div>
                <div className="px-4 pb-4 text-black-50">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/viss.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/sam-pay.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/master.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/apple-pay.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                    <div className="p-2 layout-border rounded-3">
                      <img
                        src="https://goodhand.b-cdn.net/Assets/Upload/amer-express.png"
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="shadow-none border-top">
              <Button
                variant="primary"
                className="w-100 fw-semibold py-3"
                onClick={closeGuidelineMobileModal}
              >
                OKAY, GOT IT
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};

export default PaymentLatest;
